import React from 'react';
import Input from '../../Input';
export default function Adress(props) {
    return <Input {...props}></Input>;
}
